import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Connects to data-controller="chart"
export default class extends Controller {
  static values = { options: Object }

  connect() {
    this.chart = new ApexCharts(this.element, this.optionsValue)
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
